import { gql } from '@apollo/client';

export const HANDLE_APP_CUSTOMER = gql`
  mutation HandleAppCustomer($input: PatchCustomerInput!) {
    handleAppCustomer(input: $input) {
      uid
    }
  }
`;
